import React, { memo, useState, useEffect } from "react";
import ImagesConfig from "components/ImagesConfig";
import FieldBody from "pages/OrderHistoryPage/Components/FieldBody";
import useStyles from "./styles";
import theme from "theme";

import { Grid, Button } from "@material-ui/core";
import { Images } from "config/images";
import { formatCash } from "config/constant";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

const BodyHistoryOrder = memo(
	({ products, finalAmount, productId, handleShowDefault }) => {
		const classes = useStyles();

		const [isShowWatchAdd, setShowWatchAdd] = useState(false);
		const [isShowAllProduct, setShowShowProduct] = useState(false);

		useEffect(() => {
			if (products?.length < 3) {
				return;
			}
			setShowWatchAdd(true);
		}, [products]);

		const handleWatchProductAdd = () => {
			setShowShowProduct(!isShowAllProduct);
		};

		const getHeight = () => {
			return isShowWatchAdd
				? isShowAllProduct
					? products?.length * 95
					: 190
				: products?.length * 95;
		};

		const borderBottom = index => {
			return (
				(isShowAllProduct
					? index + 1 !== products.length
					: index !== 1 && products.length !== 1) &&
				`1px solid ${theme.palette.grey[800]}`
			);
		};

		return (
			<Grid classes={{ root: classes.rootBody }}>
				<Grid style={{ height: getHeight(), overflow: "hidden" }}>
					{products?.map((product, index) => (
						<Grid
							key={index}
							classes={{ root: classes.rootProduct }}
							style={{
								borderBottom: borderBottom(index)
							}}
						>
							<Grid classes={{ root: classes.rootImage }}>
								<ImagesConfig
									image={product?.image}
									imageDefault={Images.icProductDefault}
									width={70}
									height={70}
								/>
							</Grid>
							<Grid classes={{ root: classes.rootInfo }}>
								<Grid classes={{ root: classes.name }}>
									{product?.name}
								</Grid>
								<FieldBody
									title="Số lượng thùng"
									value={product?.quantity}
								/>
							</Grid>
						</Grid>
					))}
				</Grid>
				{isShowWatchAdd && (
					<Grid
						classes={{ root: classes.btnWatchProduct }}
						onClick={() => {
							handleWatchProductAdd();
						}}
					>
						<Button
							endIcon={
								isShowAllProduct ? (
									<ExpandLess />
								) : (
									<ExpandMore />
								)
							}
						>
							{isShowAllProduct
								? "Đóng sản phẩm"
								: "Xem thêm sản phẩm"}
						</Button>
					</Grid>
				)}
				<Grid
					container
					spacing={2}
					classes={{ root: classes.totalPrice }}
				>
					<Grid item xs={7} classes={{ root: classes.subText }}>
						Thành tiền ({products?.length || 0} sản phẩm)
					</Grid>
					<Grid item xs={5} classes={{ root: classes.textPrice }}>
						{formatCash(finalAmount)} Đ
					</Grid>
				</Grid>
				<Grid
					classes={{ root: classes.btnProductDetail }}
					onClick={() => {
						handleShowDefault(productId);
					}}
				>
					<Button>Chi tiết đơn hàng</Button>
				</Grid>
			</Grid>
		);
	}
);

export default BodyHistoryOrder;
